<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>

                    <!-- Header Title -->
                    <template v-slot:headerTitle>
                        <h4 class="card-title"> {{ $t('grant_budget_management.budget_preparation') }} {{ $t('globalTrans.entry') }}</h4>
                    </template>

                    <!-- Header Action -->
                    <template v-slot:headerAction>
                        <b-button variant="primary">
                            <router-link  :to="{ path: '/grant-allowance-service/budget-management/budget-preparation'}">Back</router-link>
                        </b-button>
                    </template>

                    <!-- Body -->
                    <template v-slot:body>
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <b-overlay :show="formLoader" rounded="sm">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                                            <b-row>

                                                <!-- Organization -->
                                                <b-col sm="12" md= "4" lg="4" xl="4">
                                                    <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="org_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('grant_budget_management.organization')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="budget_mains.org_id"
                                                                :options="organizationList"
                                                                id="org_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>

                                                <!-- Fiscal Year -->
                                                <b-col sm="12" md= "4" lg="4" xl="4">
                                                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="fiscal_year_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('grant_budget_management.fiscal_year')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="budget_mains.fiscal_year_id"
                                                                :options="fiscalYearList"
                                                                id="fiscal_year_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>

                                                <b-col sm="12" md= "4" lg="4" xl="4">
                                                    <ValidationProvider name="Amount" vid='amount' :rules="{ required: true, regex: /^[1-9]\d*(\.\d{1,2})?$/ }">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="amount"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('grant_budget_management.amount')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                                id="amount"
                                                                v-model="budget_mains.amount"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                type="number"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>

                                            <!-- Service Type Wise Budget -->
                                            <b-row>
                                                <b-col xl="12" lg="12" sm="12">
                                                    <iq-card>
                                                        <div style="font-size:18px; background-color: #386389;">
                                                            <h5 class="text-white text-center">
                                                                {{ $t('grant_budget_management.service_type_wise_budget') }}
                                                            </h5>
                                                        </div>
                                                    </iq-card>
                                                </b-col>
                                            </b-row>

                                            <b-row v-for="(item,index) in budget_mains.service_types" :key=index>

                                                <!-- service_type_id -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Service Type" :vid="'service_type_type_id_' + index" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            :label-for="'service_type_type_id_' + index"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('grant_budget_management.service_type')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="item.service_type_id"
                                                                :id="'service_type_type_id_' + index"
                                                                :options="serviceTypeList"
                                                                @change="updateTmpServiceTypeList(item.service_type_id,index)"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>

                                                <!-- amount -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Amount" :vid="'service_type_amount_' + index" :rules="{ required: true, regex: /^[1-9]\d*(\.\d{1,2})?$/ }">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            :label-for="'service_type_amount_' + index"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('grant_budget_management.amount')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                                :id="'service_type_amount_' + index"
                                                                v-model="item.amount"
                                                                @keyup="totalServiceTypeBudget"
                                                                type="number"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <label class="col-sm-12 col-form-label"><br></label>
                                                    <!-- Add Button -->
                                                    <b-button type="button" :title="$t('grant_config.add_more')" v-if="index == (budget_mains.service_types.length - 1) && budget_mains.service_types.length < 3"
                                                              variant=" iq-bg-success" size="sm" @click="addServiceTypeWiseBudget()">
                                                        <i class="ri-add-line mr-1"></i>
                                                    </b-button>

                                                    <!-- Remove Button -->
                                                    <b-button type="button" :title="$t('globalTrans.delete')" v-if="index >= 0 && (budget_mains.service_types.length > 1)" variant=" iq-bg-danger" size="sm"
                                                              @click="removeServiceTypeWiseBudget(index)">
                                                        <i class="ri-delete-bin-line m-0"></i>
                                                    </b-button>
                                                </b-col>

                                                <b-col sm="12" md= "12" lg="12" xl="12">
                                                    <br>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <!-- Total Service Type Budget -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Amount" vid="service_type_budget" :rules="{ required: true, max_value: budget_mains.amount }">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="service_type_budget"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('grant_budget_management.total_service_type_budget')}}
                                                            </template>
                                                            <b-form-input
                                                                id="service_type_budget"
                                                                v-model="service_type_amount"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                :disabled="true"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <!-- Service Wise Budget -->
                                            <b-row>
                                                <b-col xl="12" lg="12" sm="12">
                                                    <iq-card>
                                                        <div style="font-size:18px; background-color: #386389;">
                                                            <h5 class="text-white text-center">
                                                                {{ $t('grant_budget_management.service_wise_budget') }}
                                                            </h5>
                                                        </div>
                                                    </iq-card>
                                                </b-col>
                                            </b-row>

                                            <b-row v-for="(item,index) in budget_mains.services" :key="'idx' + index">

                                                <!-- service_type_id -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Service Type" :vid="'service_type_id_' + index" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            :label-for="'service_type_id_' + index"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('grant_budget_management.service_type')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="item.service_type_id"
                                                                :id="'service_type_id_' + index"
                                                                :options="serviceTypeList"
                                                                @change="getServiceByTypeInServicesArray(index)"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>

                                                <!-- service_id -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Service" :vid="'service_id_' + index" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            :label-for="'service_id_' + index"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('grant_budget_management.service_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="item.service_id"
                                                                :id="'service_id_' + index"
                                                                :options="item.service_list"
                                                                @change="updateSelectedService(item.service_id, index)"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>

                                                <!-- amount -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Amount" :vid="'service_amount_' + index" rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            :label-for="'service_amount_' + index"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('grant_budget_management.amount')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                                :id="'service_amount_' + index"
                                                                v-model="item.amount"
                                                                @keyup="totalGrantServiceBudget"
                                                                type="number"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>

                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <label class="col-sm-12 col-form-label"><br></label>
                                                    <!-- Add Button -->
                                                    <b-button type="button" :title="$t('grant_config.add_more')" v-if="index === (budget_mains.services.length - 1) && budget_mains.services.length < $store.state.GrantAllowanceService.commonObj.serviceNameList.length"
                                                              variant=" iq-bg-success" size="sm" @click="addServiceWiseBudget()">
                                                        <i class="ri-add-line mr-1"></i>
                                                    </b-button>

                                                    <!-- Remove Button -->
                                                    <b-button type="button" :title="$t('globalTrans.delete')" v-show="index >= 0 && (budget_mains.services.length > 1)" variant=" iq-bg-danger" size="sm"
                                                              @click="removeServiceWiseBudget(index)">
                                                        <i class="ri-delete-bin-line m-0"></i>
                                                    </b-button>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <!-- Total Service Type Budget -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Amount" vid="grant_budget" :rules="{ max_value: grant_budget }">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="grant_budget"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('grant_budget_management.total_grant_service_budget')}}
                                                            </template>
                                                            <b-form-input
                                                                id="grant_budget"
                                                                v-model="grant_amount"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                :disabled="true"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <!-- Total Service Type Budget -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Amount" vid="allowance_budget" :rules="{ max_value: allowance_budget }">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="allowance_budget"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('grant_budget_management.total_allowance_service_budget')}}
                                                            </template>
                                                            <b-form-input
                                                                id="allowance_budget"
                                                                v-model="allowance_amount"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                :disabled="true"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <!-- Total Service Type Budget -->
                                                <b-col sm="12" md= "6" lg="3" xl="3">
                                                    <ValidationProvider name="Amount" vid="stipend_budget" :rules="{ max_value: stipend_budget }">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="stipend_budget"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('grant_budget_management.total_stipend_service_budget')}}
                                                            </template>
                                                            <b-form-input
                                                                id="stipend_budget"
                                                                v-model="stipend_amount"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                :disabled="true"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <div class="col text-right">
                                                    <b-button type="submit" @click="setStatus(0)" id="button-4" variant="primary" class="mr-2">
                                                        {{ $t('globalTrans.draft') }}
                                                    </b-button>

                                                    <b-button type="submit" @click="setStatus(1)" id="button-5" variant="primary" class="mr-2">
                                                        {{ $t('globalTrans.save') }}
                                                    </b-button>
                                                </div>
                                            </b-row>
                                        </b-form>
                                    </ValidationObserver>
                                </b-overlay>
                            </b-col>
                        </b-row>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { budgetPreparationStoreApi, budgetPreparationUpdateApi } from '../../api/routes'

export default {
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            formLoader: false,
            service_type_amount: '',
            grant_amount: '',
            allowance_amount: '',
            stipend_amount: '',
            grant_budget: '',
            allowance_budget: '',
            stipend_budget: '',
            budget_mains: {
                org_id: 0,
                fiscal_year_id: 0,
                amount: '',
                flag: 0,
                total_service_type_budget: '',
                totalGrandAmount: 0,
                service_types: [
                    {
                        service_type_id: 0,
                        amount: ''
                    }
                ],
                services: [
                    {
                        service_type_id: 0,
                        service_id: 0,
                        amount: ''
                    }
                ]
            }
        }
    },
    created () {
        if (this.$route.query.id) {
            const tmp = this.getBudgetData()
            if (tmp) {
                this.budget_mains = tmp
                this.getServiceListForExistingServices(this.budget_mains.services)
                this.totalServiceTypeBudget()
                this.totalGrantServiceBudget()
            } else {
                this.$router.push({ path: '/grant-allowance-service/budget-management/budget-preparation' })
            }
        }
    },
    mounted () {
    },
    computed: {
        serviceTypeList () {
            const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        organizationList () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        fiscalYearList () {
            return this.$store.state.commonObj.fiscalYearList
        },
        currentLocale () {
            return this.$i18n.locale
        }
    },
    watch: {
    },
    methods: {
        setStatus (status) {
          this.budget_mains.flag = status
        },
        totalGrantServiceBudget () {
           this.grant_amount = this.serviceBudget(1)
           this.allowance_amount = this.serviceBudget(2)
           this.stipend_amount = this.serviceBudget(3)
        },
        serviceBudget (id) {
            let amount = 0
            this.budget_mains.services.forEach(item => {
                if (item.amount && item.service_type_id === id) {
                    amount += parseFloat(item.amount)
                }
            })
            return amount
        },
        serviceTypeBudget (id) {
            let amount = 0
            this.budget_mains.service_types.forEach(item => {
                if (item.amount && item.service_type_id === id) {
                    amount += parseFloat(item.amount)
                }
            })
            return amount
        },
        totalServiceTypeBudget () {
            let amount = 0
            this.budget_mains.service_types.forEach(item => {
                if (item.amount) {
                    amount += parseFloat(item.amount)
                }
            })
            this.service_type_amount = amount
            this.grant_budget = this.serviceTypeBudget(1)
            this.allowance_budget = this.serviceTypeBudget(2)
            this.stipend_budget = this.serviceTypeBudget(3)
        },
        updateTmpServiceTypeList (serviceTypeId, index) {
            this.budget_mains.service_types.forEach((item, itemIndex) => {
               if (itemIndex !== index && item.service_type_id === serviceTypeId) {
                   item.service_type_id = 0
               }
            })
            this.totalGrantServiceBudget()
            this.totalServiceTypeBudget()
        },
        updateSelectedService (serviceId, index) {
            this.budget_mains.services.forEach((item, itemIndex) => {
                if (itemIndex !== index && item.service_id === serviceId) {
                    item.service_id = 0
                }
            })
        },
        addServiceTypeWiseBudget () {
            const services = [
                {
                    service_type_id: 0,
                    service_id: 0,
                    amount: ''
                }
            ]
            this.budget_mains.service_types.push({ service_type_id: 0, amount: '', services })
        },
        removeServiceTypeWiseBudget (index) {
            this.budget_mains.service_types.splice(index, 1)
            this.totalServiceTypeBudget()
        },
        addServiceWiseBudget () {
            this.budget_mains.services.push({ service_list: [], service_type_id: 0, service_id: 0, amount: '' })
        },
        removeServiceWiseBudget (index) {
            this.budget_mains.services.splice(index, 1)
            this.totalGrantServiceBudget()
        },
        getServiceListForExistingServices (services) {
            services.forEach(service => {
                service.service_list =
                    this.$store.state.GrantAllowanceService.commonObj.serviceNameList.filter(item => item.service_type_id === service.service_type_id)
            })
        },
        getBudgetData () {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.$route.query.id))
            return tmpData ? JSON.parse(JSON.stringify(tmpData)) : null
        },
        getServiceByTypeInServicesArray (index) {
            const serviceTypeId = this.budget_mains.services[index].service_type_id
            if (serviceTypeId !== 0) {
                this.budget_mains.services[index].service_list =
                    this.$store.state.GrantAllowanceService.commonObj.serviceNameList.filter(item => item.service_type_id === serviceTypeId)
            } else {
                this.budget_mains.services[index].service_list = []
            }
            // After the setting the list reset the value (service_id in this case)
            this.budget_mains.services[index].service_id = 0
            this.totalGrantServiceBudget()
        },
        async saveData () {
            this.formLoader = true
            let result = null
            this.budget_mains.approve_amount = this.budget_mains.amount
            this.budget_mains.service_types.forEach((item) => {
                item.approve_amount = item.amount
            })
            this.budget_mains.services.forEach((item) => {
                item.approve_amount = item.amount
            })
            if (this.$route.query.id) {
                result = await RestApi.putData(grantAllowanceServiceBaseUrl, `${budgetPreparationUpdateApi}/${this.$route.query.id}`, this.budget_mains)
            } else {
                result = await RestApi.postData(grantAllowanceServiceBaseUrl, budgetPreparationStoreApi, this.budget_mains)
            }
            this.formLoader = false
            if (result.success) {
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.$route.query.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$router.push({ path: '/grant-allowance-service/budget-management/budget-preparation' })
            } else {
                if (result.errors) {
                    this.$refs.form.setErrors(result.errors)
                }
            }
        }
    }
}
</script>
